import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import {
    RaikoBaseCardContainer,
    RaikoBaseContainer, RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoCustomSimpleActiveDeActiveChip, RaikoCustomTable,
    RaikoGridOneColumn, RaikoTableTitleContainer, showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {MawakibService} from "../../serverService/mawakibService/MawakibService";
import {useNavigate} from "react-router-dom";
import {css} from "@emotion/css";

export default function MawkibRegistrationLicense() {

    let page = 0
    const size = 15

    const [numberOfItems, setNumberOfItems] = useState(0);
    const [mawkibLicenseData, setMawkibLicenseData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0)

    const service = new MawakibService()

    const navigate = useNavigate()

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getMawkibRegistrationLicenseFromServer()
        }
    }, []);

    function getMawkibRegistrationLicenseFromServer() {
        setTableLoading(true)

        service.getMawakibRegistrationLicense(page, size)
            .then(response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setMawkibLicenseData([])
                response.data.map((item, index) => {
                    setMawkibLicenseData(prevState => [
                        ...prevState,
                        createMawakibLicenseTableRow(
                            item.id,
                            (page * size) + index + 1,
                            item.title,
                            item.enabled
                        )
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setTableLoading(false)
        })

    }

    function handleChangePage(newPage) {
        page = newPage
        getMawkibRegistrationLicenseFromServer()
    }

    function showMawkibLicenseDetails(licenceId) {
        let _title = ""
        mawkibLicenseData.map((item) => {
            if (item.id === licenceId) {
                _title = item.title
            }
        })
        navigate(RouteHelper.MawakibLicenseDetails.globalUrl.replace(":id", licenceId),
            {state: {title: _title}, replace: false}
        )
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.MawkibRegistrationLicense.name}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.MawakibManager.name,
                                ""
                            ),
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.MawkibRegistrationLicense.name,
                                ""
                            ),
                        ]}/>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={RouteHelper.MawkibRegistrationLicense.name}
                                amount={numberOfItems}
                            />
                            <RaikoCustomTable
                                header={mawakibLicenseTableHeader}
                                data={mawkibLicenseData}
                                pageCount={pageCount}
                                isLoading={tableLoading}
                                handlePaginationChange={handleChangePage}
                                rowClicked={showMawkibLicenseDetails}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}

function createMawakibLicenseTableRow(id, number, title, enabled) {
    return {
        id,
        number,
        title,
        enabled: <RaikoCustomSimpleActiveDeActiveChip state={enabled} activeStateTitle={"فعال"}
                                                      deActiveStateTitle={"غبر فعال"}/>
    }

}

const mawakibLicenseTableHeader = [
    {
        id: "number",
        label: "#",
    },
    {
        id: "title",
        label: "عنوان",
    },
    {
        id: "enabled",
        label: "وضعیت",
    },

]